<template>
  <div id="app">
    <Header></Header>
    <Swiper v-if="!isHome"></Swiper>
    <router-view/>
    <Footer v-if="!isHome"></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Swiper from "@/components/topSwiper"
export default {
  name: "app",
  components: { Header, Footer, Swiper },
  data() { return {} },
  computed: {
    isHome() { return this.$route.path === '/' }
  },
  watch: {
      $route(to, from) {
        if(to.path == '/detailsInfo'){
          window.location.reload();
        }
      },
  },
};
</script>

<style lang="stylus">
#app {
  overflow-x: hidden;
  background-color: #F5F3EE;
}

// .footer_top {
//   margin-top: 80px;
// }
</style>
